// Import Swiper and modules
import { Swiper } from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";

// (function () {
//   let scrollTarget = window.scrollY;
//   let isScrolling = false;

//   const scrollSpeed = 100;
//   const smoothness = 0.2;

//   function smoothScroll() {
//     const currentScroll = window.scrollY;
//     const delta = (scrollTarget - currentScroll) * smoothness;

//     if (Math.abs(delta) > 0.5) {
//       window.scrollTo(0, currentScroll + delta);
//       requestAnimationFrame(smoothScroll);
//     } else {
//       isScrolling = false;
//     }
//   }

//   window.addEventListener('wheel', function (e) {

//     const isFineTrackpad = e.deltaMode === 0 && Math.abs(e.deltaY) < 10;

//     if (isFineTrackpad) {
//       return;
//     }

//     e.preventDefault();

//     if (!isScrolling) {
//       scrollTarget = window.scrollY;
//     }

//     scrollTarget += e.deltaY > 0 ? scrollSpeed : -scrollSpeed;

//     const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
//     scrollTarget = Math.max(0, Math.min(scrollTarget, maxScroll));

//     if (!isScrolling) {
//       isScrolling = true;
//       requestAnimationFrame(smoothScroll);
//     }
//   }, { passive: false });
// })();

let originTranslateY = [];
let translateY = [];
let image_index = 0;
let mobile = true;
let windowsOs = false;

if (navigator.appVersion.indexOf("Win") != -1) {
  windowsOs = true;
}

if ($(window).width() > 992) {
  mobile = false;
} else {
  mobile = true;
}

$(document).ready(function() {
  let windowScrollTop = $(window).scrollTop();
  let windowHeight = $(window).height();

  // count sections and add to array
  let sections = [];
  $("section").each(function() {
    sections.push($(this).attr("id"));
  });

  // element after #specialization set margin-top
  $("#specialization")
    .next()
    .css("margin-top", "-100dvh");

  if (!mobile) {
    // .category_item_gallery__image mouseover
    $(".category_item_gallery__image")
      .on("mouseover", function() {
        $(this).addClass("focused");
      })
      .on("mouseout", function() {
        $(this).removeClass("focused");
      });

    $(".subcategory_items_gallery__image")
      .on("mouseover", function() {
        $(this).addClass("focused");
      })
      .on("mouseout", function() {
        $(this).removeClass("focused");
      });
  }

  if (!mobile) {
    // foreach .about_items__product .about_item p set width largest p and set everywhere
    let largest = 0;
    $(".about_items__product .about_item p").each(function() {
      if ($(this).width() > largest) {
        largest = $(this).width();
      }
    });
    $(".about_items__product .about_item p").css("width", largest + 2);
  } else {
    $(".about_items__product .about_item p").css("width", "auto");
  }

  paralaxImage(windowScrollTop, windowHeight, windowsOs);

  if ($(window).width() > 768) {
    show_from_bottom_on_scroll();
  }

  specialBlockAnimation(windowScrollTop, windowHeight);

  /* SECTION EFFECT */
  sectionEffectGrow(windowScrollTop, windowHeight);
  show_image_from_left_on_scroll(windowScrollTop, windowHeight);

  /* SWIPER INITIALIZATION */
  initializeExperiencesSwiper();

  /* ANIMATED TITLE INITIALIZATION */
  initializeAnimatedTitle();
});

$(window).resize(function() {
  if ($(window).width() > 992) {
    mobile = false;
  } else {
    mobile = true;
  }

  if (!mobile) {
    $(".about_items__product .about_item p").css(
      "width",
      $(".about_items__product .about_item:first-child p").width()
    );
  } else {
    $(".about_items__product .about_item p").css("width", "auto");
  }

  paralaxImage(windowScrollTop, windowHeight, windowsOs);

  if ($(window).width() > 768) {
    show_from_bottom_on_scroll();
  }

  specialBlockAnimation(windowScrollTop, windowHeight);

  /* SECTION EFFECT */
  sectionEffectGrow(windowScrollTop, windowHeight);
  sectionEffectBackgroundChange(windowScrollTop, windowHeight);
  show_image_from_left_on_scroll(windowScrollTop, windowHeight);
});

let deviceType = "mouse";

document.addEventListener("pointermove", event => {
  deviceType = event.pointerType;
});

// check if mouse scroll is smooth like apple mouse
let lastScrollTop = $(this).scrollTop();
let scrollPart = 0;
let scrollDirection = "down";

// method
let method = "default";

let agent = navigator.userAgent;

// check if mouse or touchpad
if (
  agent.indexOf("Mac") != -1 ||
  agent.indexOf("iPhone") != -1 ||
  agent.indexOf("iPad") != -1
) {
  method = "smooth";
}

image_index = 0;

// more is earlier
let overlay_show_limit = 2;
let text_show_limit = 2;
let button_show_limit = 2;

$(window).scroll(function() {
  let windowScrollTop = parseFloat($(window).scrollTop());
  let windowHeight = parseFloat($(window).height());

  let st = $(this).scrollTop();
  if (st > lastScrollTop) {
    scrollDirection = "down";
  } else {
    scrollDirection = "up";
  }

  if (scrollPart == 0) {
    scrollPart = st - lastScrollTop;
  }

  if (scrollPart < 0) {
    scrollPart = scrollPart * -1;
  }

  /* BUTTON SHOW */

  // more is earlier
  overlay_show_limit = 7;
  text_show_limit = 4;
  button_show_limit = 3;

  // console.log('----start-----');
  specialBlockAnimation(windowScrollTop, windowHeight);
  // console.log('----end-----');

  /* PARALAX */
  paralaxImage(windowScrollTop, windowHeight, windowsOs);

  /* SECTION EFFECT */
  sectionEffectGrow(windowScrollTop, windowHeight);
  show_image_from_left_on_scroll(windowScrollTop, windowHeight);

  if ($(window).width() > 768) {
    show_from_bottom_on_scroll();
  }

  lastScrollTop = st;
});

function sectionEffectGrow(windowScrollTop, windowHeight) {
  if ($(window).width() > 991) {
    $(".section_effect_grow").each(function() {
      let thisHeight = $(this).height();
      let thisOffsetTop = $(this).offset().top;

      let grow =
        (windowScrollTop +
        windowHeight -
        thisOffsetTop + // == 0
          windowHeight / 2) / // == thisHeight
        (windowHeight / 80); // speed - vráceno na původní hodnotu

      if (grow > 100) {
        grow = 100;
      }

      if (grow < 85) {
        grow = 85;
      }

      $(this).css("transform", "scale(" + grow + "%)");

      if ($(this).find(".block_overlay").length) {
        if (grow >= 100) {
          $(this)
            .find(".block_overlay")
            .css({
              opacity: 1
            });
        } else {
          $(this)
            .find(".block_overlay")
            .css({
              opacity: 0
            });
        }
      }
      if ($(this).find(".section_effect_grow_text").length) {
        if (grow >= 100) {
          $(this)
            .find(".section_effect_grow_text")
            .css({
              opacity: 1
            });
        } else {
          $(this)
            .find(".section_effect_grow_text")
            .css({
              opacity: 0
            });
        }
      }
    });
  }
}

function paralaxImage(windowScrollTop, windowHeight, windowsOs) {
  // Pouze na desktopu a pouze pro elementy s třídou parallax_image__move
  if ($(window).width() > 768) {
    $(".parallax_image__move").each(function() {
      let thisHeight = $(this).height();
      let thisOffsetTop = $(this).offset().top;

      let translateY =
        -(
          (
            windowScrollTop +
            windowHeight -
            thisOffsetTop + // == 0
            windowHeight / 2
          ) // == thisHeight
        ) /
        (windowHeight / 300); // speed

      if (translateY < -400) {
        translateY = -400; // offset
      }

      $(this).css("transform", "translateY(" + translateY + "px)");
    });
  }
}

function show_from_bottom_on_scroll() {
  let i = 0;
  let count = parseInt($(".show_from_bottom_on_scroll").length);
  let text = $(".our_story_about__text");

  $(".show_from_bottom_on_scroll").each(function() {
    $(this).css({
      position: "sticky",
      top: text.outerHeight() + "px",
      height: text.height() + "px"
    });

    if (i == 0) {
      $(this)
        .find("h4")
        .css({
          marginTop: 50 + "px"
        });
    } else {
      $(this)
        .find("h4")
        .css({
          marginTop: 115 * i + 50 + "px"
        });
    }

    i++;
  });
}

function show_image_from_left_on_scroll(windowScrollTop, windowHeight) {
  $(".show_image_from_left_on_scroll_block").each(function() {
    let thisElement = $(this);
    let thisHeight = thisElement.outerHeight();
    let thisOffsetTop = thisElement.offset().top;

    if (windowScrollTop + windowHeight > thisOffsetTop + thisHeight / 4) {
      thisElement
        .find(".show_image_from_left_on_scroll_image")
        .addClass("active");
      setTimeout(function() {
        thisElement
          .find(".show_image_from_left_on_scroll_content")
          .addClass("active");
      }, 1000);
    }
  });
}

function specialBlockAnimation(windowScrollTop, windowHeight) {
  $(".specialization_item").each(function(key) {
    let allOffsetTop = parseFloat($(".specialization_items").offset().top);
    let thisHeight = parseFloat($(this).outerHeight() + windowHeight);

    let thisOffsetTop = parseFloat(
      allOffsetTop + key * thisHeight + (key + 1) * ((windowHeight / 100) * 12)
    );

    if ($(this).find(".specialization_item__overlay").length) {
      if (windowScrollTop > thisOffsetTop + thisHeight / overlay_show_limit) {
        $(this)
          .find(".specialization_item__overlay")
          .css({
            opacity: 1
          });
      } else {
        $(this)
          .find(".specialization_item__overlay")
          .css({
            opacity: 0
          });
      }
    }

    if ($(this).find(".specialization_item__content_text_p").length) {
      if (windowScrollTop > thisOffsetTop + thisHeight / text_show_limit) {
        $(this)
          .find(
            ".specialization_item__content_text_p, .specialization_item__content_text_h"
          )
          .css({
            opacity: 1
          });
      } else {
        $(this)
          .find(
            ".specialization_item__content_text_p, .specialization_item__content_text_h"
          )
          .css({
            opacity: 0
          });
      }
    } else {
      button_show_limit = text_show_limit;
    }

    if ($(this).find(".specialization_item__content_button").length) {
      if (windowScrollTop > thisOffsetTop + thisHeight / button_show_limit) {
        $(this)
          .find(".specialization_item__content_button")
          .css({
            opacity: 1
          });
      } else {
        $(this)
          .find(".specialization_item__content_button")
          .css({
            opacity: 0
          });
      }
    }
  });
}

function goTo(id) {
  $("html, body").animate(
    {
      scrollTop: $(id).offset().top
    },
    1000
  );
}

function handleMobileMenu() {
  $(".mobile_menu").toggleClass("active");
  $("body").toggleClass("overflow-hidden");
}

$(document).click(function(event) {
  if (!$(event.target).closest(".mobile_menu").length) {
    if (
      $(".mobile_menu").hasClass("active") &&
      !$(event.target).closest(".menu_hamburger").length
    ) {
      $(".mobile_menu").removeClass("active");
      $("body").removeClass("overflow-hidden");
    }
  }
});

/* SWIPER FUNCTIONS */
function initializeExperiencesSwiper() {
  if (document.querySelector(".experiences-swiper")) {
    const experiencesSwiper = new Swiper(".experiences-swiper", {
      // Configure modules
      modules: [Navigation, Pagination, Autoplay],

      // Basic settings
      slidesPerView: "auto",
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,

      // Navigation
      navigation: {
        nextEl: ".custom-swiper-next",
        prevEl: ".custom-swiper-prev"
      },

      // Pagination
      pagination: {
        el: ".experiences-swiper-pagination",
        clickable: true,
        dynamicBullets: true
      },

      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
          centeredSlides: false
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false
        },
        1200: {
          slidesPerView: "auto",
          spaceBetween: 16,
          centeredSlides: false
        }
      },

      // Effects
      effect: "slide",
      speed: 600,

      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: "Předchozí slide",
        nextSlideMessage: "Následující slide",
        paginationBulletMessage: "Přejít na slide {{index}}"
      }
    });
  }
}

// Scroll-triggered video for Experiences section
document.addEventListener("DOMContentLoaded", function() {
  const video = document.querySelector(".experiences_video");

  if (video) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Video je viditelné, spustit přehrávání
            video.play().catch(e => {
              console.log("Video autoplay failed:", e);
            });
          } else {
            // Video není viditelné, pozastavit přehrávání
            video.pause();
          }
        });
      },
      {
        threshold: 0.5 // Spustit když je 50% videa viditelné
      }
    );

    observer.observe(video);
  }

  // Scroll-triggered video for PrototypeCategory section
  const citationVideo = document.querySelector(".citation_background_video");

  if (citationVideo) {
    const citationObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Video je viditelné, spustit přehrávání
            citationVideo.play().catch(e => {
              console.log("Citation video autoplay failed:", e);
            });
          } else {
            // Video není viditelné, pozastavit přehrávání
            citationVideo.pause();
          }
        });
      },
      {
        threshold: 0.5 // Spustit když je 50% videa viditelné
      }
    );

    citationObserver.observe(citationVideo);
  }
});

/* ANIMATED TITLE FUNCTION */
function initializeAnimatedTitle() {
  const animatedTitle = document.querySelector(".animated-title");

  if (!animatedTitle) return;

  // Rozdělí text na jednotlivá písmena nebo slova (podle velikosti obrazovky)
  function splitTextToLetters(element) {
    const lines = element.querySelectorAll(".animated-line");
    const isMobile = window.innerWidth <= 768;

    lines.forEach(line => {
      const text = line.textContent;
      line.innerHTML = "";

      if (isMobile) {
        // Na mobilních zařízeních rozdělujeme na slova
        const words = text.split(" ");
        words.forEach((word, wordIndex) => {
          if (wordIndex > 0) {
            // Přidáme mezeru mezi slovy
            const spaceSpan = document.createElement("span");
            spaceSpan.classList.add("animated-letter", "space");
            spaceSpan.innerHTML = "&nbsp;";
            line.appendChild(spaceSpan);
          }

          // Vytvoříme wrapper pro celé slovo
          const wordWrapper = document.createElement("span");
          wordWrapper.classList.add("animated-word");

          // Rozdělíme slovo na písmena
          for (let i = 0; i < word.length; i++) {
            const char = word[i];
            const span = document.createElement("span");
            span.classList.add("animated-letter");
            span.textContent = char;
            wordWrapper.appendChild(span);
          }

          line.appendChild(wordWrapper);
        });
      } else {
        // Na desktopu rozdělujeme na jednotlivá písmena
        for (let i = 0; i < text.length; i++) {
          const char = text[i];
          const span = document.createElement("span");
          span.classList.add("animated-letter");

          if (char === " ") {
            span.classList.add("space");
            span.innerHTML = "&nbsp;";
          } else {
            span.textContent = char;
          }

          line.appendChild(span);
        }
      }
    });
  }

  // Animuje písmena postupně
  function animateLetters() {
    const letters = animatedTitle.querySelectorAll(".animated-letter");

    letters.forEach((letter, index) => {
      setTimeout(() => {
        letter.classList.add("animate");
      }, index * 25); // 25ms zpoždění mezi písmeny - rychlejší
    });
  }

  // Spustí animaci
  function startAnimation() {
    splitTextToLetters(animatedTitle);

    // Malé zpoždění před začátkem animace
    setTimeout(() => {
      animateLetters();
    }, 200);
  }

  // Spustí animaci při načtení stránky
  startAnimation();
}
